module.exports = __webpack_public_path__ + "static/media/redo-enabled.82524c91.svg";